<template>
  <div class="home">
    <Menu></Menu>
    <v-container>
    <v-row class="xcompact">
      <v-col cols="12" sm="12" md="12">
        <v-btn small color="primary" dark @click="doLogOut">Log Out</v-btn>
      </v-col>
    </v-row>

  </v-container>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'

export default {
  name: "LogOutView",
  components: {
    Menu
  },
  methods: {
    doLogOut() {
      this.$logOut()
      //this.$store.commit('setLoggedIn', false)
      localStorage.removeItem('token')
      this.$router.push('/')
    }
  },
  mounted: function() {
    console.log('Logout mounted')
    this.doLogOut()
  }
}
</script>

<style scoped>

</style>
